import {BrowserModule} from '@angular/platform-browser';
import {ApplicationRef, DoBootstrap, ErrorHandler, Injector, LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LoginFormModule} from './login/login-form/login-form.module';
import {AuthModule, ConfigModule, SharedModule} from 'shared';
import {HttpClientModule} from '@angular/common/http';
import {HomeModule} from './home/home.module';
import {ToolbarModule} from './toolbar/toolbar.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GlobalErrorHandler} from 'shared';
import localeFr from '@angular/common/locales/fr';
import {DatePipe, registerLocaleData} from '@angular/common';
import {createCustomElement} from '@angular/elements';
import {MapFieldPopupComponent} from './map-fields/map-field-popup/map-field-popup.component';
import {MapFieldsModule} from './map-fields/map-fields.module';
import {MapTractorPopupComponent} from './map-tractors/map-tractor-popup/map-tractor-popup.component';
import {MapPoiPopupComponent} from './map-poi/map-poi-popup/map-poi-popup.component';
import {MapPoiPopupModule} from './map-poi/map-poi-popup/map-poi-popup.module';
import {FieldEditorMapPopupComponent} from './fields/field-editor-map-popup/field-editor-map-popup.component';
import {FieldEditorMapPopupModule} from './fields/field-editor-map-popup/field-editor-map-popup.module';
import {FieldEditorMapControlsComponent} from './fields/field-editor-map-controls/field-editor-map-controls.component';
import {FieldEditorMapControlsModule} from './fields/field-editor-map-controls/field-editor-map-controls.module';
import {environment} from '../environments/environment';
import {RecoveryFormModule} from './login/recovery-form/recovery-form.module';
import {RecoveryChangePasswordFormModule} from './login/recovery-change-password-form/recovery-change-password-form.module';
import {TransportInterventionsMapPoiReportPopupComponent} from './transport-interventions/transport-interventions-map-poi-report-popup/transport-interventions-map-poi-report-popup.component';
import {TransportInterventionsMapPoiReportPopupModule} from './transport-interventions/transport-interventions-map-poi-report-popup/transport-interventions-map-poi-report-popup.module';

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ConfigModule.forRoot({
      url: environment.configFile,
      auth: true,
    }),
    AuthModule.forRoot({
      clientLoginUrl: '/login',
      apiLoginUrl: '/auth/login',
      apiRecoveryUrl: '/auth/recovery',
      apiRecoveryChangePasswordUrl: '/auth/recovery-change-password',
      apiRefreshUrl: '/auth/refresh-token',
      apiMeUrl: '/me',
    }),
    SharedModule,
    LoginFormModule,
    RecoveryFormModule,
    RecoveryChangePasswordFormModule,
    HomeModule,
    ToolbarModule,
    MapFieldsModule,
    MapPoiPopupModule,
    FieldEditorMapPopupModule,
    FieldEditorMapControlsModule,
    TransportInterventionsMapPoiReportPopupModule,
  ],
  providers: [
    DatePipe,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {provide: LOCALE_ID, useValue: 'fr-FR'},
  ],
  // bootstrap: [AppComponent]
})
export class AppModule implements DoBootstrap {

  constructor(private injector: Injector) {
  }

  ngDoBootstrap(appRef: ApplicationRef) {
    this.registerElements();
    appRef.bootstrap(AppComponent);
  }

  private registerElements() {

    // Convert `MapFieldPopupComponent` to a custom element.
    const MapFieldPopupComponentElement = createCustomElement(MapFieldPopupComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('field-popup', MapFieldPopupComponentElement);

    // Convert `MapTractorPopupComponent` to a custom element.
    const MapTractorPopupComponentElement = createCustomElement(MapTractorPopupComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('tractor-popup', MapTractorPopupComponentElement);

    // Convert `MapTractorPopupComponent` to a custom element.
    const MapPoiPopupComponentElement = createCustomElement(MapPoiPopupComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('poi-popup', MapPoiPopupComponentElement);

    // Convert `MapTractorPopupComponent` to a custom element.
    const FieldEditorMapPopupComponentElement = createCustomElement(FieldEditorMapPopupComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('field-editor-map-popup', FieldEditorMapPopupComponentElement);

    // Convert `MapTractorPopupComponent` to a custom element.
    const FieldEditorMapControlsComponentElement = createCustomElement(FieldEditorMapControlsComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('field-editor-map-controls', FieldEditorMapControlsComponentElement);

    // Convert `MapTractorPopupComponent` to a custom element.
    const TransportInterventionsMapPoiReportPopupElement = createCustomElement(TransportInterventionsMapPoiReportPopupComponent, {injector: this.injector});
    // Register the custom element with the browser.
    customElements.define('transport-intervention-map-poi-report-popup', TransportInterventionsMapPoiReportPopupElement);

  }
}
